import type { NovelData } from "@/mocks/novels";

const xh = (title: string) => [
  `第一章 ${title}·初入江湖`,
  "第二章 命运的转折",
  "第三章 第一次交手",
  "第四章 暗流涌动",
  "第五章 破境之夜",
  "第六章 崭露锋芒",
  "第七章 风起云涌",
  "第八章 再进一步",
];

export const moreNovels: NovelData[] = [
  {
    id: "jiu-xiao-zhan-hun",
    title: "九霄战魂",
    author: "铁马冰河",
    category: "xuanhuan",
    categoryName: "玄幻",
    cover:
      "https://readdy.ai/api/search-image?query=fantasy%20novel%20cover%2C%20armored%20warrior%20with%20glowing%20battle%20aura%20standing%20amid%20storm%20clouds%20and%20lightning%2C%20deep%20indigo%20and%20molten%20gold%20tones%2C%20dramatic%20painterly%20illustration&width=600&height=800&seq=novel-cover-13&orientation=portrait",
    intro: "少年孟霄体内封着一缕上古战魂，每逢危难便会苏醒。他要在万千宗门的围猎中，为自己走出一条血路。",
    tags: ["热血", "战魂", "爽文"],
    status: "连载",
    wordCount: 3870000,
    updatedAt: "2026-10-12",
    clicks: 7410000,
    favorites: 356000,
    chapterTitles: xh("九霄"),
  },
  {
    id: "tian-ming-dan-dao",
    title: "天命丹道",
    author: "青禾道人",
    category: "xuanhuan",
    categoryName: "玄幻",
    cover:
      "https://readdy.ai/api/search-image?query=fantasy%20alchemist%20novel%20cover%2C%20young%20man%20in%20green%20robes%20holding%20a%20glowing%20pill%20furnace%20surrounded%20by%20coiling%20green%20flames%2C%20herbal%20mist%2C%20emerald%20and%20bronze%20tones%2C%20detailed%20illustration&width=600&height=800&seq=novel-cover-14&orientation=portrait",
    intro: "丹道凋零的年代，江辞意外得到一枚上古丹方残卷。一炉丹，一步命，他要在废土般的世界里重开丹道盛世。",
    tags: ["炼丹", "种田", "慢热"],
    status: "连载",
    wordCount: 2540000,
    updatedAt: "2026-10-11",
    clicks: 3980000,
    favorites: 187000,
    chapterTitles: xh("丹心"),
  },
  {
    id: "huang-gu-shen-ti",
    title: "荒古神体",
    author: "苍山负雪",
    category: "xuanhuan",
    categoryName: "玄幻",
    cover:
      "https://readdy.ai/api/search-image?query=epic%20fantasy%20cover%2C%20muscular%20youth%20with%20tribal%20tattoos%20and%20faint%20golden%20veins%20glowing%20on%20his%20body%2C%20ancient%20stone%20ruins%20behind%2C%20earthy%20brown%20and%20amber%20tones%2C%20dramatic%20lighting&width=600&height=800&seq=novel-cover-15&orientation=portrait",
    intro: "荒古时代的神体血脉在少年身上苏醒。别人修的是灵气，他修的是这副能撼动山河的肉身。",
    tags: ["炼体", "热血", "升级流"],
    status: "连载",
    wordCount: 3120000,
    updatedAt: "2026-10-09",
    clicks: 5120000,
    favorites: 224000,
    chapterTitles: xh("神体"),
  },
  {
    id: "jian-yu-tong-xing",
    title: "剑与同行",
    author: "陌上初尘",
    category: "xuanhuan",
    categoryName: "玄幻",
    cover:
      "https://readdy.ai/api/search-image?query=fantasy%20cover%2C%20two%20young%20swordsmen%20standing%20back%20to%20back%20on%20a%20cliff%2C%20swords%20gleaming%20with%20soft%20white%20light%2C%20twilight%20sky%2C%20muted%20blue%20and%20warm%20orange%20tones%2C%20painterly%20style&width=600&height=800&seq=novel-cover-16&orientation=portrait",
    intro: "一个持剑问天，一个以身为鞘。两个人的路，从同一场雪夜开始，也注定要在巅峰重逢。",
    tags: ["双男主", "剑修", "群像"],
    status: "连载",
    wordCount: 2180000,
    updatedAt: "2026-10-08",
    clicks: 3460000,
    favorites: 168000,
    chapterTitles: xh("同行"),
  },
  {
    id: "wan-ling-shen-jue",
    title: "万灵神诀",
    author: "北冥有鱼",
    category: "xuanhuan",
    categoryName: "玄幻",
    cover:
      "https://readdy.ai/api/search-image?query=fantasy%20cover%2C%20beast%20tamer%20surrounded%20by%20glowing%20spirit%20animals%20including%20a%20white%20tiger%20and%20crane%2C%20misty%20forest%20temple%2C%20teal%20and%20warm%20gold%20tones%2C%20rich%20illustration&width=600&height=800&seq=novel-cover-17&orientation=portrait",
    intro: "能与万灵沟通的少年，被视作不祥。直到有一天，沉睡在山川中的古老巨兽，为他睁开了眼睛。",
    tags: ["御兽", "热血", "治愈"],
    status: "连载",
    wordCount: 2960000,
    updatedAt: "2026-10-07",
    clicks: 4180000,
    favorites: 196000,
    chapterTitles: xh("万灵"),
  },
  {
    id: "yin-yang-zhui-xu",
    title: "阴阳追虚",
    author: "子不语",
    category: "xuanhuan",
    categoryName: "玄幻",
    cover:
      "https://readdy.ai/api/search-image?query=fantasy%20cover%2C%20robed%20figure%20with%20a%20black%20and%20white%20yin%20yang%20halo%20behind%20him%2C%20stars%20and%20ink%20swirls%2C%20monochrome%20with%20a%20single%20amber%20accent%2C%20mystical%20atmosphere&width=600&height=800&seq=novel-cover-18&orientation=portrait",
    intro: "阴阳两界的缝隙里，藏着无数不该存在的东西。谢临是唯一一个能在缝隙中来回行走的人。",
    tags: ["玄奇", "悬念", "强强"],
    status: "连载",
    wordCount: 1860000,
    updatedAt: "2026-10-06",
    clicks: 2840000,
    favorites: 142000,
    chapterTitles: xh("追虚"),
  },
  {
    id: "lie-huo-zhi-dao",
    title: "烈火之道",
    author: "赤月",
    category: "xuanhuan",
    categoryName: "玄幻",
    cover:
      "https://readdy.ai/api/search-image?query=fantasy%20cover%2C%20fire%20cultivator%20engulfed%20in%20crimson%20and%20orange%20flames%20with%20embers%20flying%2C%20volcanic%20landscape%2C%20intense%20warm%20glow%2C%20dynamic%20painterly%20illustration&width=600&height=800&seq=novel-cover-19&orientation=portrait",
    intro: "火系功法被称作最鲁莽的道，可林炎偏要把这一炉烈火，烧到最极致的境界。",
    tags: ["热血", "爽文", "升级流"],
    status: "连载",
    wordCount: 2740000,
    updatedAt: "2026-10-10",
    clicks: 4620000,
    favorites: 208000,
    chapterTitles: xh("烈火"),
  },
  {
    id: "xing-chen-zhi-zhu",
    title: "星辰之主",
    author: "夜观星",
    category: "xuanhuan",
    categoryName: "玄幻",
    cover:
      "https://readdy.ai/api/search-image?query=fantasy%20cover%2C%20figure%20standing%20on%20a%20floating%20star%20platform%20with%20constellations%20swirling%20around%2C%20deep%20midnight%20blue%20and%20silver%20tones%2C%20cosmic%20mystical%20illustration&width=600&height=800&seq=novel-cover-20&orientation=portrait",
    intro: "每个人都有属于自己的星辰，只是无人能看见。直到少年抬头的那一刻，满天星斗都为他亮了。",
    tags: ["星象", "热血", "群像"],
    status: "连载",
    wordCount: 3080000,
    updatedAt: "2026-10-05",
    clicks: 4360000,
    favorites: 202000,
    chapterTitles: xh("星辰"),
  },
  {
    id: "di-yi-jian-zong",
    title: "第一剑宗",
    author: "白衣渡江",
    category: "xuanhuan",
    categoryName: "玄幻",
    cover:
      "https://readdy.ai/api/search-image?query=fantasy%20cover%2C%20grand%20sword%20sect%20pavilion%20on%20a%20misty%20mountain%20with%20countless%20floating%20swords%2C%20jade%20green%20and%20white%20tones%2C%20elegant%20chinese%20painting%20style&width=600&height=800&seq=novel-cover-21&orientation=portrait",
    intro: "剑宗没落三百年，只剩下一座空荡荡的山门。少年背着师父留下的剑，要去把这座山门重新立起来。",
    tags: ["剑修", "宗门", "热血"],
    status: "连载",
    wordCount: 3320000,
    updatedAt: "2026-10-12",
    clicks: 5240000,
    favorites: 246000,
    chapterTitles: xh("剑宗"),
  },
  {
    id: "hun-dun-gu-jing",
    title: "混沌古镜",
    author: "无相",
    category: "xuanhuan",
    categoryName: "玄幻",
    cover:
      "https://readdy.ai/api/search-image?query=fantasy%20cover%2C%20ancient%20bronze%20mirror%20floating%20in%20darkness%20reflecting%20a%20whole%20world%2C%20swirling%20grey%20and%20amber%20mist%2C%20mysterious%20ominous%20atmosphere%2C%20detailed%20illustration&width=600&height=800&seq=novel-cover-22&orientation=portrait",
    intro: "一面照不出人脸的镜子，却映得出整个世界的前世今生。得到它的人，注定要背负起一段沉重的因果。",
    tags: ["悬念", "玄奇", "暗黑"],
    status: "连载",
    wordCount: 1980000,
    updatedAt: "2026-10-04",
    clicks: 2960000,
    favorites: 138000,
    chapterTitles: xh("古镜"),
  },
  {
    id: "shan-hai-yi-ren",
    title: "山海异闻录",
    author: "拾遗",
    category: "xuanhuan",
    categoryName: "玄幻",
    cover:
      "https://readdy.ai/api/search-image?query=fantasy%20cover%2C%20ancient%20scroll%20unrolled%20revealing%20mythical%20beasts%20and%20mountains%2C%20ink%20wash%20style%2C%20sepia%20and%20dark%20teal%20tones%2C%20scholarly%20mystical%20composition&width=600&height=800&seq=novel-cover-23&orientation=portrait",
    intro: "山与海之间，藏着太多未写入史书的奇闻。一个走遍天下的说书人，把这些故事一一记了下来。",
    tags: ["志怪", "群像", "治愈"],
    status: "完结",
    wordCount: 1460000,
    updatedAt: "2026-09-26",
    clicks: 2340000,
    favorites: 126000,
    chapterTitles: xh("山海"),
  },
  {
    id: "zhan-shen-jue-xing",
    title: "战神觉醒",
    author: "孤云野鹤",
    category: "xuanhuan",
    categoryName: "玄幻",
    cover:
      "https://readdy.ai/api/search-image?query=fantasy%20cover%2C%20battlefield%20with%20a%20lone%20figure%20kneeling%20amid%20broken%20weapons%20as%20golden%20light%20erupts%20around%20him%2C%20dust%20and%20embers%2C%20dramatic%20cinematic%20illustration%2C%20warm%20and%20dark%20tones&width=600&height=800&seq=novel-cover-24&orientation=portrait",
    intro: "倒下的人可以再站起来，只要心里那口气还没散。少年从尸山血海里爬起，觉醒了属于战神的意志。",
    tags: ["热血", "爽文", "战斗"],
    status: "连载",
    wordCount: 3580000,
    updatedAt: "2026-10-11",
    clicks: 5820000,
    favorites: 268000,
    chapterTitles: xh("战意"),
  },
  {
    id: "kong-jian-zhong-sheng",
    title: "空剑重生",
    author: "桑榆未晚",
    category: "xuanhuan",
    categoryName: "玄幻",
    cover:
      "https://readdy.ai/api/search-image?query=fantasy%20cover%2C%20rebirth%20scene%20with%20a%20translucent%20sword%20spirit%20and%20a%20rebuilding%20figure%20made%20of%20light%2C%20soft%20blue%20and%20warm%20gold%20tones%2C%20ethereal%20atmosphere%2C%20illustration&width=600&height=800&seq=novel-cover-25&orientation=portrait",
    intro: "一剑落空，身死道消。可当他重新睁眼，发现自己回到了拜师前的那一天。重来一次，他要赢回全部。",
    tags: ["重生", "剑修", "爽文"],
    status: "连载",
    wordCount: 2660000,
    updatedAt: "2026-10-09",
    clicks: 4120000,
    favorites: 194000,
    chapterTitles: xh("重生"),
  },
  {
    id: "gui-dao-jue-dian",
    title: "诡道绝巅",
    author: "影随",
    category: "xuanhuan",
    categoryName: "玄幻",
    cover:
      "https://readdy.ai/api/search-image?query=dark%20fantasy%20cover%2C%20hooded%20figure%20with%20glowing%20purple%20runes%20and%20drifting%20black%20smoke%2C%20ruined%20temple%20at%20night%2C%20ominous%20deep%20violet%20and%20grey%20tones%2C%20detailed%20illustration&width=600&height=800&seq=novel-cover-26&orientation=portrait",
    intro: "世人称他诡道，惧他诡道，却无人知他走的每一步，都是为了把那扇不该打开的门重新关上。",
    tags: ["暗黑", "反套路", "悬念"],
    status: "连载",
    wordCount: 2240000,
    updatedAt: "2026-10-03",
    clicks: 3240000,
    favorites: 152000,
    chapterTitles: xh("诡道"),
  },
  {
    id: "long-yu-tian-xia",
    title: "龙御天下",
    author: "山河故人",
    category: "xuanhuan",
    categoryName: "玄幻",
    cover:
      "https://readdy.ai/api/search-image?query=epic%20fantasy%20cover%2C%20enormous%20golden%20dragon%20coiling%20around%20a%20mountain%20above%20a%20vast%20empire%2C%20warm%20amber%20and%20deep%20teal%20sky%2C%20grand%20cinematic%20painterly%20style&width=600&height=800&seq=novel-cover-27&orientation=portrait",
    intro: "龙脉之主诞生于乱世。少年携龙气而行，从一城之地走到天下棋局中央，要让山河重归安宁。",
    tags: ["权谋", "热血", "群像"],
    status: "连载",
    wordCount: 3480000,
    updatedAt: "2026-10-08",
    clicks: 5060000,
    favorites: 238000,
    chapterTitles: xh("龙御"),
  },
  {
    id: "wu-ji-shu-lin",
    title: "无极书林",
    author: "砚书",
    category: "xuanhuan",
    categoryName: "玄幻",
    cover:
      "https://readdy.ai/api/search-image?query=fantasy%20cover%2C%20endless%20floating%20library%20of%20glowing%20books%20in%20a%20void%2C%20a%20young%20scholar%20reading%20at%20the%20center%2C%20warm%20amber%20and%20deep%20brown%20tones%2C%20magical%20atmosphere&width=600&height=800&seq=novel-cover-28&orientation=portrait",
    intro: "书读万卷，自成大道。当一个穷书生发现书里的字会活过来，他的人生也随之翻开了新的一页。",
    tags: ["书院", "轻松", "慢热"],
    status: "连载",
    wordCount: 1720000,
    updatedAt: "2026-10-02",
    clicks: 2180000,
    favorites: 118000,
    chapterTitles: xh("书林"),
  },
  {
    id: "tie-xue-rong-yao",
    title: "铁血荣耀",
    author: "关山月",
    category: "xuanhuan",
    categoryName: "玄幻",
    cover:
      "https://readdy.ai/api/search-image?query=fantasy%20cover%2C%20warrior%20in%20heavy%20dark%20armor%20raising%20a%20banner%20on%20a%20battlefield%20at%20dawn%2C%20smoke%20and%20warm%20red%20light%2C%20gritty%20cinematic%20illustration&width=600&height=800&seq=novel-cover-29&orientation=portrait",
    intro: "在强者为尊的世界里，没有背景的少年只有一身铁骨。他要凭这身铁骨，为自己挣来一份真正的荣耀。",
    tags: ["热血", "战斗", "爽文"],
    status: "连载",
    wordCount: 2860000,
    updatedAt: "2026-10-07",
    clicks: 4080000,
    favorites: 186000,
    chapterTitles: xh("铁血"),
  },
  {
    id: "ling-hun-fu-shi",
    title: "灵魂符师",
    author: "符离",
    category: "xuanhuan",
    categoryName: "玄幻",
    cover:
      "https://readdy.ai/api/search-image?query=fantasy%20cover%2C%20runes%20and%20glowing%20talismans%20floating%20around%20a%20focused%20young%20man%2C%20warm%20gold%20light%20against%20dark%20green%20backdrop%2C%20intricate%20detailed%20illustration&width=600&height=800&seq=novel-cover-30&orientation=portrait",
    intro: "符箓一道讲究天赋，而他的天赋，是能听见每一道符画的低语。当符与魂共鸣，奇迹就此发生。",
    tags: ["符箓", "慢热", "热血"],
    status: "连载",
    wordCount: 2060000,
    updatedAt: "2026-10-05",
    clicks: 2760000,
    favorites: 132000,
    chapterTitles: xh("符师"),
  },
  {
    id: "xiu-luo-mo-dian",
    title: "修罗魔典",
    author: "血衣侯",
    category: "xuanhuan",
    categoryName: "玄幻",
    cover:
      "https://readdy.ai/api/search-image?query=dark%20fantasy%20cover%2C%20fierce%20warrior%20with%20crimson%20aura%20and%20a%20tattered%20black%20cloak%20standing%20on%20a%20skull%20mountain%2C%20deep%20red%20and%20charcoal%20tones%2C%20intense%20dramatic%20illustration&width=600&height=800&seq=novel-cover-31&orientation=portrait",
    intro: "他翻开那本被诅咒的魔典时，就知道自己再也回不去了。可有些路，一旦踏上，就只能走到黑。",
    tags: ["暗黑", "热血", "反套路"],
    status: "连载",
    wordCount: 2980000,
    updatedAt: "2026-10-10",
    clicks: 4460000,
    favorites: 214000,
    chapterTitles: xh("修罗"),
  },
  {
    id: "cang-qiong-bu-tian",
    title: "苍穹补天",
    author: "补天人",
    category: "xuanhuan",
    categoryName: "玄幻",
    cover:
      "https://readdy.ai/api/search-image?query=fantasy%20cover%2C%20figure%20flying%20toward%20a%20cracked%20glowing%20sky%20behind%20a%20broken%20heavenly%20gate%2C%20awe%20inspiring%20scale%2C%20deep%20blue%20and%20warm%20gold%20tones%2C%20epic%20painterly%20illustration&width=600&height=800&seq=novel-cover-32&orientation=portrait",
    intro: "天穹之上裂开了一道缝，有东西正从缝里往下看。少年被选中去补那道裂痕，代价是他再也回不了人间。",
    tags: ["热血", "群像", "悬念"],
    status: "连载",
    wordCount: 3260000,
    updatedAt: "2026-10-12",
    clicks: 4980000,
    favorites: 232000,
    chapterTitles: xh("补天"),
  },
];